import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getShowroomsByIP } from '../actions/location-actions';
import { isValidArray } from '../components/utilities/validations';

export const useBranchId = () => {
	const dispatch = useDispatch();
	const locations = useSelector((state) => state.locations);
	const [branchId, setBranchId] = useState(null);

	useEffect(() => {
		let params = new URLSearchParams(window.location.search);
		let branch = params.get('branch');

		if (branch) setBranchId(branch);
	}, []);

	useEffect(() => {
		let params = new URLSearchParams(window.location.search);
		let branch = params.get('branch');

		if (branch || (isValidArray(locations?.showrooms) && locations.showrooms[0].branch_id === branchId)) return;

		if (!locations.showrooms) dispatch(getShowroomsByIP());

		if (isValidArray(locations?.showrooms)) {
			setBranchId(locations.showrooms[0].branch_id);
		}

		// eslint-disable-next-line react-hooks/exhaustive-deps -- stringify necessary for comparison
	}, [branchId, JSON.stringify(locations.showrooms)]);

	return branchId;
};
